import React, { PropTypes } from 'react';
import { RadioButton } from 'material-ui';
import Icon from '../../../tc-ui/icon';
import R, {
  isEmpty,
  prop,
  equals,
  update,
  append,
  flatten,
  all,
  allPass,
  has,
  remove,
} from 'ramda';
import SingleRoom from './single-room';

const BeddingConfigEdit = ({ beddingConfig, sendEditToReducer, style }) => {
  const setState = state => {
    const { rooms } = state;
    const flattenedBeds = rooms ? flatten(rooms) : [];
    // R.all does not handle empty array
    const isValid = !isEmpty(flattenedBeds) && all(allPass([has('bedType'), has('count'), prop('bedType'), prop('count')]), flattenedBeds);
    sendEditToReducer({ value: state, isBeddingConfigInvalid: !isValid });
  };
  const { isApartment, rooms } = beddingConfig;
  return (
    <div style={R.merge({ maxHeight: '500px', overflowY: 'scroll' }, style)}>
      <div>
        <div style={{ padding: '24px 0 0 32px', marginBottom: '8px', color: 'black' }}>What type of room is this? </div>
        <RadioButton
          checked={equals(isApartment, false) && !isEmpty(rooms)}
          label="Individual Bedroom (One Room)"
          onCheck={() => setState({ isApartment: false, rooms: [[[{ count: 1 }]]] })}
          labelStyle={{ color: isApartment ? 'grey' : 'black' }}
          style={{ paddingLeft: '32px' }}
        />
        <RadioButton
          checked={equals(isApartment, true)}
          label="Apartment (Multiple rooms)"
          onCheck={() => setState({ isApartment: true, rooms: [[[{ count: 1 }]]] })}
          labelStyle={{ color: equals(isApartment, false) ? 'grey' : 'black' }}
          style={{ paddingLeft: '32px' }}
        />
      </div>
      <br/>
      <div style={{ display: rooms ? 'block' : 'none' }}>
        <div style={{ minHeight: '100px' }}>
          {
            rooms ? rooms.map((beddingConfigs, index) => (
              <SingleRoom
                key={index}
                forSingleRoom={equals(isApartment, false)}
                removeARoom={() => setState({ isApartment, rooms: remove(index, 1, rooms) })}
                beddingConfigs={beddingConfigs}
                roomName={equals(isApartment, true) ? `Room ${index + 1}` : ''}
                updateBeddingConfigs={newConfigs => setState({ isApartment, rooms: update(index, newConfigs, rooms) })}
              />
            )) : <div/>
          }
          <div
            style={{
              display: isApartment ? 'block' : 'none',
              borderBottom: '1px solid #ededed',
              borderTop: '1px solid #ededed',
              backgroundColor: '#fafafa',
              height: '62px',
              lineHeight: '62px',
              textAlign: 'center',
              color: '#21c4d8',
              cursor: 'pointer',
            }}
            onClick={() => setState({ isApartment, rooms: append([[{ count: 1 }]], rooms) })}
          >
            <div
              className="description-segments-add"
              style={{ color: '#00bcd4', cursor: 'pointer', margin: '0 0 16px 32px' }}
            >
              <Icon className="tc-icon-add description-segments-add-icon"/>
              <span className="description-segments-add-label">Add Another Room for This Apartment</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

BeddingConfigEdit.propTypes = {
  beddingConfig: PropTypes.object,
  sendEditToReducer: PropTypes.func,
};

export default BeddingConfigEdit;



// WEBPACK FOOTER //
// ./src/app/components/profile/edit-modal/bedding-config/bedding-config.jsx